import { ComponentProps, FC } from 'react'
import { SvgComponent } from '@platform/ui'

type Props = {
  icon?: ComponentProps<typeof SvgComponent>['name']
  text?: string
  value?: string
}

export const CourseDateWithIcon: FC<Props> = ({ icon = null, text = '', value = '' }) => {
  return (
    <>
      {icon && <SvgComponent name={icon} />}
      <span>
        {text}
        {value && ':'}
      </span>
      <span>{value}</span>
    </>
  )
}
